<template>
	<input
		v-model="computedValue"
		:type="type"
		class="c-form-text-input"
		v-bind="$attrs"
		:aria-label="computedLabel || null"
		v-on="computedListeners"
	/>
</template>

<script>
export default {
	name: 'FormTextInput',
	inheritAttrs: false,

	props: {
		type: {
			type: String,
			default: 'text',
		},
		value: {
			type: String,
			default: '',
		},
		label: {
			type: String,
			default: null,
		},
	},

	computed: {
		computedValue: {
			get() {
				return this.value;
			},
			set(value) {
				this.$emit('input', value);
			},
		},

		computedLabel() {
			return typeof this.label === 'string'
				? this.label
				: this.$attrs.placeholder;
		},

		computedListeners() {
			const listeners = {
				...this.$listeners,
			};
			delete listeners.input;
			return listeners;
		},
	},
};
</script>

<style lang="postcss">
.c-form-text-input {
	@apply w-full h-auto py-12 flex items-center bg-transparent text-white border-b border-current text-input-form placeholder-white;
}
</style>
